




































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import listBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import VWidget from '@/components/VWidget.vue';

class PageRatioRequest extends PageRequest {
    year: number = parseInt(Util.abp.clock.today().substr(0, 4));
    vehicle_type: number = Util.abp.list.get('T_VEHICLE', 'P').id;
}

@Component({
    components: { VWidget }
})
export default class Ratioss extends listBase {
    entity: string = 'ratio';
    pagerequest: PageRatioRequest = new PageRatioRequest();
    selected: any = null;

    get loading() {
        return this.$store.state.ratio.loading;
    }

    get loadingConcept() {
        return this.$store.state.concept.loading;
    }

    get vehicles() {
        let vehicles = Util.abp.list.getList('T_VEHICLE');
        return vehicles;
    }
    
    get list() {
        return this.$store.state.ratio.ratios;
    }

    get years() {
        return this.gCommonList('years');
    }

    async changeRatio(item) {
        await this.$store.dispatch({
            type: 'ratio/' + (item.id > 0 ? 'update' : 'create'),
            data: item
        });
    }

    async getpage() {
        await this.$store.dispatch({
            type: 'ratio/getRatios',
            data: this.pagerequest
        });
    }

    async mounted() {
        await this.getpage();
    }

    created() {

    }
}